export default __webpack_public_path__ + "static/media/property_662.cb4599be.png";